/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import Editor from '@/components/Editor';

import { ArtifactFieldWidget } from '../components/ArtifactForm/ArtifactForm.types';

export const OrientacaoNarrativeWidget: ArtifactFieldWidget = ({
  control: { field },
}) => {
  const content = typeof field.value === 'string' ? field.value : '';

  return (
    <Editor
      content={content}
      onChange={field.onChange}
      showFooterActions={false}
    />
  );
};
